import type React from "react";
import { X } from "lucide-react";
import { Button } from "@planta-v2/pds-ui/button";
import { i18n } from "@frontend/i18n";

export function IgnoredButton(): React.JSX.Element {
  return (
    <div className="flex flex-col items-center gap-2">
      <Button variant="secondary" disabled className="w-full gap-2" size="lg">
        <X className="h-4 w-4" />
        {i18n.t("user.directory.profile.cta.ignored")}
      </Button>
      <p className="text-pds-2xs text-center text-muted-foreground">
        {i18n.t("user.directory.profile.cta.ignoredHelp")}
      </p>
    </div>
  );
}
